import {
  Directive,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { LoginService } from '../services/Login.service';
import jwt_decode from 'jwt-decode';
import { JwtData } from '../interfaces/jwt-data';
@Directive({
  selector: '[isNotAuthorized]',
})
export class IsNotAuthorizedDirective implements OnInit {
  private _roleName = '';
  private _userRole = '';

  @Input('isNotAuthorized')
  public set roleName(roleName: string) {
    this._roleName = roleName;
    const token = localStorage.getItem('token');
    const tokenData = new JwtData(jwt_decode(token!, { header: false }));
    this._userRole = tokenData.role;
    const isValid = this.loginService.validRole(tokenData.role, roleName);
    if (!isValid) {
      this.container.clear();
    }
  }

  constructor(
    element: TemplateRef<any>,
    private container: ViewContainerRef,
    private loginService: LoginService
  ) {
    container.clear();
    loginService.loginStatus$.subscribe((result) => {
      if(result === false) {
        container.createEmbeddedView(element);
      }
      else {
        container.clear();
        return;
      }
    });
  }

  ngOnInit(): void {}
}
